import "./App.css";
import React, { useEffect } from "react";
import { Slide } from "react-awesome-reveal";

// import { Parallax } from "react-parallax";
import Container from "react-bootstrap/Container";
import Particles from "react-particles-js";

import { particlesOptions } from "./particlesOptions";
//Components
import MyNavbar from "./components/MyNavbar/MyNavbar";
import MyCarrousel from "./components/MyCarrousel/MyCarrousel";
import TitleMessage from "./components/TitleMessage/TitleMessage";
import About from "./pages/About/About";
// import Curriculum from "./pages/Curriculum/Curriculum";
import Skills from "./pages/Skills/Skills";
import Projects from "./pages/Projects/Projects";
import ContactMe from "./pages/Contact/ContactMe";
import Footer from "./components/Footer/Footer";
const App = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 800, behavior: "smooth" });
    }, 2000);
  }, []);

  return (
    <div className="mainContainer">
      <MyNavbar />
      {/* <Pulse triggerOnce> */}
      <MyCarrousel />
      <Particles
        className="particles particles-box"
        params={particlesOptions}
      />
      <TitleMessage />
      {/* </Pulse> */}

      <Container className="container-box rounded">
        <Slide duration={2000} triggerOnce>
          <About />
        </Slide>
      </Container>
      {/*    <hr />
      <Curriculum /> */}
      <Skills />
      <Projects />
      <hr />
      <ContactMe />
      <Footer />
    </div>
  );
};

export default App;
